/**
 * 部分 GET 接口用「同一参数名重复出现」绑定 Spring 端的 List（如 statusList=a&statusList=b）。
 * axios 默认 paramsSerializer 在个别调用链下不够直观，此处集中拼装 query string。
 *
 * @param {Record<string, *>} scalarParams - 已剔除重复键后的普通参数（会进入 params）
 * @param {string} repeatedKey - 重复输出的 query 名，如 statusList
 * @param {Array<string|number|boolean>} [repeatedValues]
 * @param {{ omitFalseBoolean?: boolean }} [options] - true 时不序列化值为 false 的布尔参数（与材料领用列表一致）
 * @returns {string}
 */
export function serializeGetQueryWithRepeatedKey (scalarParams, repeatedKey, repeatedValues, options = {}) {
  const { omitFalseBoolean = false } = options;
  const parts = [];

  Object.keys(scalarParams || {}).forEach((k) => {
    const v = scalarParams[k];
    if (v === undefined || v === null || v === '') return;
    if (omitFalseBoolean && typeof v === 'boolean' && v === false) return;
    parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  });

  (repeatedValues || []).forEach((s) => {
    if (s === undefined || s === null || s === '') return;
    parts.push(`${encodeURIComponent(repeatedKey)}=${encodeURIComponent(s)}`);
  });

  return parts.join('&');
}

/**
 * 供 axios.get(url, cfg) 使用：从 inputParams 中拆出 repeatedKey，其余作为 params，
 * paramsSerializer 走 {@link serializeGetQueryWithRepeatedKey}。
 *
 * @param {Record<string, *>} inputParams
 * @param {string} [repeatedKey='statusList']
 * @param {{ omitFalseBoolean?: boolean }} [options]
 * @returns {{ params: Record<string, *>, paramsSerializer: () => string }}
 */
export function buildAxiosGetConfigWithRepeatedKey (inputParams, repeatedKey = 'statusList', options = {}) {
  const raw = inputParams || {};
  const list = raw[repeatedKey];
  const rest = { ...raw };
  delete rest[repeatedKey];

  return {
    params: rest,
    paramsSerializer: () => serializeGetQueryWithRepeatedKey(rest, repeatedKey, list, options)
  };
}
